import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Facebook } from 'lucide-react';
import { CONTACT_INFO } from '../mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-captiva-beige-dark text-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="lg:col-span-1">
            <img
              src="https://customer-assets.emergentagent.com/job_84359d72-7fbf-43ad-8138-bff5ec896218/artifacts/trrith5g_A3BE837C-E2BC-48D9-8E99-A9D1FFBEF393.PNG"
              alt="Captiva Photobooth"
              className="h-16 w-auto mb-4"
            />
            <p className="text-sm text-gray-300 leading-relaxed">
              Location de photobooths premium pour vos événements inoubliables en Belgique.
            </p>
          </div>

          {/* Navigation rapide */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-captiva-gold-light transition-colors duration-200">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/photobooths" className="text-sm hover:text-captiva-gold-light transition-colors duration-200">
                  Nos Photobooths
                </Link>
              </li>
              <li>
                <Link to="/tarifs" className="text-sm hover:text-captiva-gold-light transition-colors duration-200">
                  Tarifs
                </Link>
              </li>
              <li>
                <Link to="/galerie" className="text-sm hover:text-captiva-gold-light transition-colors duration-200">
                  Galerie
                </Link>
              </li>
              <li>
                <Link to="/avis" className="text-sm hover:text-captiva-gold-light transition-colors duration-200">
                  Avis Clients
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-captiva-gold-light transition-colors duration-200">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Événements</h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>Mariages</li>
              <li>Anniversaires</li>
              <li>Soirées privées</li>
              <li>Événements corporate</li>
              <li>Galas & réceptions</li>
              <li>Lancements de produits</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Contact</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href={`tel:${CONTACT_INFO.phone}`}
                  className="flex items-center text-sm hover:text-captiva-gold-light transition-colors duration-200 group"
                >
                  <Phone className="h-4 w-4 mr-2 text-captiva-gold" />
                  <span>{CONTACT_INFO.phone}</span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${CONTACT_INFO.email}`}
                  className="flex items-center text-sm hover:text-captiva-gold-light transition-colors duration-200 group"
                >
                  <Mail className="h-4 w-4 mr-2 text-captiva-gold" />
                  <span>{CONTACT_INFO.email}</span>
                </a>
              </li>
              <li className="flex items-center text-sm">
                <MapPin className="h-4 w-4 mr-2 text-captiva-gold" />
                <span>{CONTACT_INFO.location}</span>
              </li>
            </ul>

            {/* Social Media */}
            <div className="mt-6 flex space-x-4">
              <a
                href="https://www.instagram.com/captiva.photobooth?igsh=cHVza241aG9qMmdz"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-captiva-beige flex items-center justify-center hover:bg-captiva-gold transition-colors duration-200 group"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="https://www.facebook.com/share/1CsYMNfdaf/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-captiva-beige flex items-center justify-center hover:bg-captiva-gold transition-colors duration-200 group"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-captiva-beige">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-300">
              © {currentYear} Captiva Photobooth. Tous droits réservés.
            </p>
            <div className="flex space-x-6 text-sm text-gray-300">
              <a href="#" className="hover:text-captiva-gold-light transition-colors duration-200">
                Mentions légales
              </a>
              <a href="#" className="hover:text-captiva-gold-light transition-colors duration-200">
                Politique de confidentialité
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
